import { useEffect, useState } from "react";

type WalletType = "apple" | "google" | null;

export function useDigitalWallet() {
  const [availableWallet, setAvailableWallet] = useState<WalletType>(null);

  useEffect(() => {
    const checkWalletAvailability = async () => {

      if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
        setAvailableWallet("apple");
        return;
      }

    //  const scriptId = "google-pay-script";
    //  const loadGooglePayScript = () => new Promise<void>((resolve) => {
    //    if (document.getElementById(scriptId)) return resolve();

    //    const script = document.createElement("script");
    //    script.id = scriptId;
    //    script.src = "https://pay.google.com/gp/p/js/pay.js";
    //    script.async = true;
    //    script.onload = () => resolve();
    //    document.body.appendChild(script);
    //  });

    //  await loadGooglePayScript();

    //  if (window.google?.payments) {
    //    const paymentsClient = new window.google.payments.api.PaymentsClient({
    //      environment: "PRODUCTION",
    //    });

    //    const isReadyToPayRequest: google.payments.api.IsReadyToPayRequest = {
    //      apiVersion: 2,
    //      apiVersionMinor: 0,
    //      allowedPaymentMethods: [
    //        {
    //          type: "PAYMENT_GATEWAY",
    //          parameters: {
    //            gateway: "cielo",
    //            gatewayMerchantId: process.env.REACT_APP_GOOGLE_PAY_MERCHANT_ID || "",
    //          },
    //        },
    //      ],
    //    };

    //    try {
    //      const response = await paymentsClient.isReadyToPay(isReadyToPayRequest);
    //      if (response.result) {
    //        setAvailableWallet("google");
    //      }
    //    } catch (err) {
    //      console.error("Erro ao verificar Google Pay:", err);
    //    }
    //  }
    };

    checkWalletAvailability();
  }, []);

  return availableWallet;
}
